<template>
  <div class='InputCateg'>
    <div class="texto">
      <input v-if="checkbox" @change="Update" :checked="active" type="checkbox">
      <component :tam="'22px'" style="margin-left: 5px" :is="data.icon"/>
      <label>{{ data.name }}</label>
    </div>
    <div class="actions">
      <edit-icon @click="changeCategEdit({ ...data });$emit('edit:catecogia')" :options="{ width: '22px', heigth: '22px' }"/>
      <delete-icon @click="Del" :options="{ width: '22px', heigth: '22px' }"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { icons } from '@/components/icons'
import EditIcon from '../../Icons/EditIcon'
import DeleteIcon from '../../Icons/DeleteIcon'
export default {
  name: 'InputCateg',
  components: { ...icons, EditIcon, DeleteIcon },
  props: {
    data: Object,
    categProd: {
      type: Array,
      default: () => []
    },
    // fora do cadastro de produto (página de categorias) não há produto para marcar
    checkbox: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    active () {
      return this.categProd.indexOf(this.data.name) !== -1
    }
  },
  methods: {
    ...mapActions(['setProdCateg', 'ChangeProdEdit', 'changeCategEdit', 'SetModal']),
    Update () {
      this.setProdCateg({ name: this.data.name, active: this.active })
    },
    Del () {
      this.SetModal({ 
        component: 'AskAction',
        active: true,
        ask: 'Os produtos serão desvinculados desta categoria. Deseja excluir?',
        action: '_DeleteCategory',
        payload: this.data
      })
    }
  }
}
</script>

<style scoped>
.InputCateg {
  display: flex;
  padding: 2%;
  align-items: center;
  border-bottom: thin solid #CCCCCC;
}

.texto {
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: start;
}

.actions {
}

label {
  padding-left: 2%;
}

img {
  width: 20px;
  height: 20px;
}
</style>
